import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

// buildThingEntities and toKeywordString return nothing for a page that names
// no known entity or keyword; leave such fields out instead of emitting [] or "".
const omitEmptyDiscoveryFields = (key, value) => (
    (key === 'about' && Array.isArray(value) && value.length === 0)
    || (key === 'keywords' && value === '')
        ? undefined
        : value
);

const serializeJsonLd = (value) => (
    JSON.stringify(value, omitEmptyDiscoveryFields, 2)
        .replace(/</g, '\\u003c')
        .replace(/\u2028/g, '\\u2028')
        .replace(/\u2029/g, '\\u2029')
);

/**
 * Renders a Schema.org JSON-LD script tag in the document head.
 * @param {Object} props
 * @param {string} props.type - The Schema.org type (e.g., 'Organization', 'WebSite').
 * @param {Object} props.data - The structured data object.
 */
const SchemaOrg = ({ data }) => {
    if (!data) return null;

    const items = Array.isArray(data) ? data : [data];

    return (
        <Helmet>
            {items.map((item, index) => (
                <script key={`schema-${index}`} type="application/ld+json">
                    {serializeJsonLd(item)}
                </script>
            ))}
        </Helmet>
    );
};

SchemaOrg.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]).isRequired,
};

export default SchemaOrg;
